  <script setup>
  import { defineProps, computed } from 'vue'
  const props = defineProps({
    items: []
  })

  const items = computed(() => props.items)
  const categoryBinding = computed(()=>[...new Set(items.value.map(item => item.kategori))])
  console.log(items)
</script>

<template>

  <div v-if="items" class="text-white  w-full min-h-[100px] flex flex-col gap-3">
    <div v-for="kategori in categoryBinding" v-bind:key="kategori" class="v-for flex flex-col">
      <div class="capitalize font-bold text-lg">{{ kategori }}</div>
      <div v-for="item in items.filter(item=> item.kategori == kategori)" v-bind:key="item.nama" class="flex gap-1 ps-4 w-full">
        <div class="nama flex-0 whitespace-nowrap">{{ item.nama }}</div>
        <div class="gap flex-grow overflow-hidden">
          <span
            class="inline-block w-full truncate">........................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................</span>
        </div>
        <div class="price flex-0">{{ item.harga }}</div>
      </div>
    </div>
  </div>
</template>